import * as React from "react"
import { cn } from '../../cn'

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  return (
    <textarea
      data-component="Textarea"
      data-package="@appic/ui-components"
      data-testid="textarea"
      className={cn(
        // text-base (16px) on mobile, text-sm (14px) at sm+ — iOS Safari
        // auto-zooms inputs with font-size < 16px on focus, which is
        // disorienting in a chat composer. The mobile bump prevents
        // the zoom; desktop stays compact.
        "flex min-h-20 w-full rounded-md border border-input-border bg-input px-3 py-2 text-base sm:text-sm text-foreground shadow-sm transition-colors",
        "placeholder:text-muted-foreground",
        "hover:border-accent/40",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = "Textarea"

export { Textarea }